<template>
  <div class="relative w-full">
    <div class="text-2xl font-medium capitalize">
      {{ componentType.replaceAll("_", " ") }}
    </div>

    <div>
      <div class="text-lg mt-6 font-medium">
        {{
          component_record
            ? component_record[componentType]
              ? $moment.utc(component_record[componentType]).local().format("MMMM DD, YYYY")
              : $t("never")
            : ""
        }}
      </div>
    </div>
    <div>
      <button
        class="btn primary-btn absolute right-6 bottom-4 w-36 pl-2 font-normal"
        @click="$emitter.emit('sendEmail', { record: component_record })">
        <Mail color="white" class="mr-2" /> {{ $t("Contact Now") }}
      </button>
    </div>
  </div>
</template>

<script>
import { useLayoutItemSharedLogic } from "@/components/shared/pages/useLayoutItemSharedLogic.js"
import { Mail } from "lucide-vue-next"

export default {
  components: { Mail },
  props: {
    linkedRecord: null,
    connectTo: null,
    componentType: null
  },
  emits: [],
  data() {
    return {
      loading: false,
      record_error: false,
      component_record: null
    }
  },
  created() {
    const { loading, record_error, component_record } = useLayoutItemSharedLogic(
      this.$props,
      this.postGetComponentRecord,
      this.registerListeners,
      this.unregisterListeners
    )
    this.loading = loading
    this.record_error = record_error
    this.component_record = component_record
  },
  methods: {
    postGetComponentRecord() {},
    registerListeners() {},
    unregisterListeners() {}
  }
}
</script>
